import axios from 'axios';
import { FOOTERURL } from '../index';

export const getFooterApi = (postData) => {
  return axios.post(FOOTERURL, JSON.stringify(postData));
};
